/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".navbar-avatar[_ngcontent-%COMP%]{border-bottom:none!important;margin-left:10px!important}.navbar-avatar[_ngcontent-%COMP%]::after{display:none}.navbar-avatar[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:38px;width:38px;border-radius:50%}"];
export { styles as styles };
